// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__24P3b","header":"MergedInvoice_header__1Sw-9"};